/**
 * Retry timing for the outbox, and the rule for giving up on an item.
 *
 * "Giving up" never means dropping it. After ten consecutive failures an item
 * is marked `failed` and shown in Settings with a retry button — an outbox item
 * is never silently discarded, because the entry it carries exists on exactly
 * one device until it lands.
 */

/** 1s, 2s, 4s … capped at five minutes, exactly as ARCHITECTURE.md specifies. */
export const FIRST_RETRY_MS = 1000;
export const MAX_RETRY_MS = 5 * 60 * 1000;

/** Consecutive failures before an item is surfaced as a problem. */
export const MAX_ATTEMPTS = 10;

export function retryDelayMs(attempts: number): number {
  if (attempts <= 0) return FIRST_RETRY_MS;

  const delay = FIRST_RETRY_MS * 2 ** (attempts - 1);
  return Math.min(delay, MAX_RETRY_MS);
}

export function hasGivenUp(attempts: number): boolean {
  return attempts >= MAX_ATTEMPTS;
}
